import React from "react";

import type { NavAdBlock } from "@reactivated";

import { ImageChooserBlock } from "@thelabnyc/thelabui/src/components/ImageChooserBlock";

import { Clickable } from "../Clickables";
import { useHeaderContext } from "./HeaderContext";

import styles from "./NavAd.module.scss";

export const NavAd = ({
    item: {
        link,
        image: desktop_image,
        mobile_image,
        column_width,
        full_width_mobile,
    },
}: {
    item: NavAdBlock;
}) => {
    const { isMobileLayout } = useHeaderContext();

    if (!link || !desktop_image) return <></>;

    const image = isMobileLayout
        ? (mobile_image ?? desktop_image)
        : desktop_image;

    const columnWidth = Number(column_width) || 4;

    const desktopAspectRatio = columnWidth >= 4 ? "16 / 9" : "5 / 6";
    const mobileAspectRatio = full_width_mobile ? "16 / 9" : "5 / 6";
    const aspectRatio = isMobileLayout ? mobileAspectRatio : desktopAspectRatio;

    const desktopSizes = Math.round((columnWidth / 12) * 100);
    const mobileSizes = full_width_mobile ? 100 : 50;
    const sizes = `${isMobileLayout ? mobileSizes : desktopSizes}vw`;

    return (
        <Clickable simpleLink={link} className={styles.root}>
            <ImageChooserBlock
                value={image}
                attrs={{
                    className: styles.picture,
                    style: { aspectRatio },
                }}
                imageAttrs={{ className: styles.image, loading: "lazy" }}
                sizes={sizes}
            />
            <span className={styles.linkText}>{link.display_name}</span>
        </Clickable>
    );
};
